import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { environment } from '../../../../../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { JobTitleService } from '../../../../../../services/jobtitle/jobtitle.service';
import { ConfigService } from '../../../../../../services/config/config.service';


@Component({
    selector: 'fuse-employee-excel-configuration',
    templateUrl: './employee-excel-configuration.component.html',
    styleUrls: ['./employee-excel-configuration.component.scss'],
    animations: fuseAnimations
})
export class EmployeeExcelConfigurationComponent implements OnInit {
    @BlockUI() blockUI: NgBlockUI;
    formGroup;


    public attrs = [];
    public typeEmployees = [];
    public jobTitles = [];
    public shifts = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EmployeeExcelConfigurationComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        public typeEmployeeService: TypeEmployeeService,
        public shiftService: ShiftService,
        private jobTitleService: JobTitleService,
        private configService: ConfigService
    ) {
        console.log('FuseAddStudentComponent > data', data);
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        Observable.combineLatest(
            this.typeEmployeeService.getAll(),
            this.jobTitleService.getAll(),
            this.shiftService.getAll(),
            this.configService.getEmployeeAttrs()
        ).subscribe(([typeEmployees, jobTitles, shifts, employeeAttrs]) => {
            this.typeEmployees = typeEmployees.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });

            this.jobTitles = jobTitles.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });

            this.shifts = shifts.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });

            employeeAttrs.forEach(e => {
                e.Checked = false;
            });

            this.attrs = employeeAttrs;

            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    required(list) {
        return list.filter(e => e.Checked).length === 0;
    }


    save() {
        const attrs = this.attrs.filter(e => e.Checked).map(e => e.Code);
        const typeEmployees = this.typeEmployees.filter(e => e.Checked).map(e => e.Id);
        const jobTitles = this.jobTitles.filter(e => e.Checked).map(e => e.Id);
        const shifts = this.shifts.filter(e => e.Checked).map(e => e.Id);
        console.log('d', environment.backendUri + 'report/excel/employee/' + attrs + '/' + jobTitles + '/' + typeEmployees + '/' + shifts);
        window.open(environment.backendUri + 'report/excel/employee/' + attrs + '/' + jobTitles + '/' + typeEmployees + '/' + shifts, '_new');
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/components/employee-excel-configuration/employee-excel-configuration.component.ts